<template lang="pug">
BriqButton(wide v-on="$listeners" :class="extraClasses")
  span(v-if="this.pending" v-html="activeLabel")
  slot(v-else)
</template>

<script>
export default {
  data() {
    return {
      dotCount: 3,
    }
  },
  props: {
    pending: Boolean,
    pendingLabel: { type: String, default: 'Pending' },
    variant: {
      type: String,
      default: 'main',
      validator: variant => variant === 'main' || variant === 'delete' || variant === 'jumbo',
    },
  },
  computed: {
    activeLabel() {
      return this.pending ? this.pendingLabel + this.dots : ''
    },
    dots() {
      let thing = ''
      for (let i = 0; i < 3; i++) {
        if (i < this.dotCount) {
          thing += '<span>.<span>'
        } else thing += '<span style="visibility: hidden">.<span>'
      }
      return thing
    },
    extraClasses() {
      return {
        'submit-button': true,
        'button-main': this.variant === 'main',
        'button-jumbo': this.variant === 'jumbo',
        'button-delete': this.variant === 'delete',
        pending: this.pending,
      }
    },
  },
  methods: {
    updateDots() {
      this.dotCount = (this.dotCount % 3) + 1
      if (this.pending)
        setTimeout(() => {
          this.updateDots()
        }, 300)
    },
  },
  watch: {
    pending(newVal) {
      if (newVal) {
        this.updateDots()
      }
    },
  },
}
</script>

<style scoped lang="stylus">
redButtonBackground = #e93838
redButtonBorder = #cb2828

.submit-button.pending
  border 1px solid #009BFF
  background-color white
  color #009BFF
  cursor wait

.submit-button.button-delete
  border-color redButtonBorder
  background-color redButtonBackground
  color #fff

  &:hover, &:focus
    background-color redButtonBorder

  &.pending
    background-color white
    border 1px solid redButtonBorder
    color redButtonBackground
</style>
